<template>
  <div>{{ message.content.message || "New Agent Assined" }}</div>
</template>

<script>
export default {
  name: "agentAssign",
  data() {
    return {};
  },
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
